import React from 'react';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import ReviewAction from '../../components/ReviewAction';
import TaskLinkAction from './TaskLinkAction';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const TasksActions = ({ category, readStatus }) => {
  const { allowRefresh, allowApprove, taskLinkEnabled } = Selectors.useTasksActions({ category });
  const refresh = Events.useRefreshTasks(category);

  return (
    <>
      {allowRefresh && (<RefreshActionMenu onClick={() => refresh({ page: 1 })} readStatus={readStatus} />)}
      {allowApprove && (<ReviewAction />)}
      {taskLinkEnabled && (<TaskLinkAction />)}
    </>
  );
};

export default TasksActions;
